<footer class="tw-bg-background-alt tw-text-center tw-px-5" [class]="paddingClasses()">
  <ng-content></ng-content>
</footer>
